import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const MenuWithCursorIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.25 4.5L16.75 4.5C17.1642 4.5 17.5 4.83579 17.5 5.25V9.625L19 10.75V5.25C19 4.00736 17.9926 3 16.75 3L3.25 3C2.00736 3 1 4.00736 1 5.25L1 14.75C1 15.9926 2.00736 17 3.25 17H14V15.5L3.25 15.5C2.83579 15.5 2.5 15.1642 2.5 14.75L2.5 5.25C2.5 4.83579 2.83579 4.5 3.25 4.5Z"
          fill={color}
        />
        <path
          d="M15.0325 15.7768L14.99 10.1724C14.9884 9.96635 15.2227 9.84697 15.3885 9.96933L19.8976 13.298C20.0768 13.4303 20.0066 13.7132 19.7863 13.7463L18.0379 14.0097L19.5133 16.9055C19.7014 17.2745 19.5546 17.7261 19.1856 17.9142C18.8165 18.1022 18.3649 17.9555 18.1768 17.5864L16.7014 14.6907L15.4607 15.9504C15.3044 16.1091 15.0342 15.9996 15.0325 15.7768Z"
          fill={color}
        />
        <path
          d="M5 6.5C4.72386 6.5 4.5 6.72386 4.5 7C4.5 7.27614 4.72386 7.5 5 7.5L14.5 7.5C14.7761 7.5 15 7.27614 15 7C15 6.72386 14.7761 6.5 14.5 6.5L5 6.5Z"
          fill={color}
        />
        <path
          d="M4.5 10C4.5 9.72386 4.72386 9.5 5 9.5H11C11.2761 9.5 11.5 9.72386 11.5 10C11.5 10.2761 11.2761 10.5 11 10.5H5C4.72386 10.5 4.5 10.2761 4.5 10Z"
          fill={color}
        />
        <path
          d="M5 12.5C4.72386 12.5 4.5 12.7239 4.5 13C4.5 13.2761 4.72386 13.5 5 13.5L12.5 13.5C12.7761 13.5 13 13.2761 13 13C13 12.7239 12.7761 12.5 12.5 12.5L5 12.5Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
